import {
  sanitizeTextForAnalytics,
  pushAnalyticsObjToDataLayer,
  getSearchDataLayerDetails,
} from "@/utils/helper"
import {
  HELP_AND_FAQ,
  ARTICLE_LIST_CLICK,
  SEARCH_RESULTS_PRODUCT_NAVIGATION,
  SEARCH_RESULTS,
  MAIN_CONTENT_AREA,
  SEARCH_TYPE,
} from "@/components/Shared/Search/v1/InspirationTile/analytics/constant"

const generateLinkURL = contentUrl => {
  if (contentUrl) {
    return contentUrl.indexOf("http") === -1
      ? window.location.origin + contentUrl
      : contentUrl
  }
  return "n/a"
}

const getProductNavigationAnalyticsForHelpResults = (
  contentUrl,
  categoryName,
  title,
  page,
  searchResultDataLayerObj
) => {
  const linkURL = generateLinkURL(contentUrl)
  return {
    eventAction: SEARCH_RESULTS_PRODUCT_NAVIGATION,
    eventName: SEARCH_RESULTS_PRODUCT_NAVIGATION,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${sanitizeTextForAnalytics(
      categoryName
    )}:${sanitizeTextForAnalytics(title)}`,
    internalLinkPosition: SEARCH_RESULTS,
    internalLinkType: `${SEARCH_RESULTS}:help tiles`,
    internalLinkZoneName: `${SEARCH_RESULTS}:help:${MAIN_CONTENT_AREA}`,
    internalLinkURL: linkURL,
    clickInternalLinks: "true",
    ...(page && page === "search"
      ? getSearchDataLayerDetails(searchResultDataLayerObj)
      : {}),
  }
}

const getProductNavigationAnalytics = (
  data,
  type,
  page,
  searchResultDataLayerObj
) => {
  const { contentUrl, categoryName, title } = data
  let articleType
  let linkType
  let zoneName
  const linkURL = generateLinkURL(contentUrl)
  if (type === "Help" && page === "article") {
    articleType = HELP_AND_FAQ
  }
  if (type === "Help" && page !== "article") {
    return getProductNavigationAnalyticsForHelpResults(
      contentUrl,
      categoryName,
      title,
      page,
      searchResultDataLayerObj
    )
  }
  if (articleType) {
    linkType = articleType + ":navigation"
    zoneName = articleType + ":article list"
  } else {
    const searchType =
      type === SEARCH_TYPE.RESOURCES
        ? SEARCH_TYPE.RESOURCES
        : type || SEARCH_TYPE.INSPIRATION

    linkType = `${SEARCH_RESULTS}:${searchType} tiles`
    zoneName = `${SEARCH_RESULTS}:${searchType}:${MAIN_CONTENT_AREA}`
  }
  return {
    eventAction: articleType
      ? articleType + `:${ARTICLE_LIST_CLICK}`
      : SEARCH_RESULTS_PRODUCT_NAVIGATION,
    eventName: articleType
      ? articleType + `:${ARTICLE_LIST_CLICK}`
      : SEARCH_RESULTS_PRODUCT_NAVIGATION,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: sanitizeTextForAnalytics(title),
    internalLinkPosition: articleType || SEARCH_RESULTS,
    internalLinkType: linkType,
    internalLinkZoneName: zoneName,
    internalLinkURL: linkURL,
    clickInternalLinks: "true",
    ...(page && page === "search"
      ? getSearchDataLayerDetails(searchResultDataLayerObj)
      : {}),
  }
}

export const addProductNavigationAnalytics = (
  data,
  type,
  page,
  searchResultDataLayerObj
) => {
  const eventInfo = getProductNavigationAnalytics(
    data,
    type,
    page,
    searchResultDataLayerObj
  )
  pushAnalyticsObjToDataLayer(eventInfo)
}
